import { Fragment } from 'react';

import Column, { ColumnsRow, ColumnsWrapper } from 'bloko/blocks/column';
import VSpacing from 'bloko/blocks/vSpacing';

import NotFoundContent from 'components/NotFound';

import { Header } from 'components/Header/Header';

const NotFound = () => (
    <Fragment>
        <Header />
        <ColumnsWrapper>
            <ColumnsRow>
                <Column xs="4" s="8" m="12" l="16">
                    <article className="not-found">
                        <NotFoundContent />
                        <VSpacing base={12} />
                    </article>
                </Column>
            </ColumnsRow>
        </ColumnsWrapper>
    </Fragment>
);

export default NotFound;
